export default function dutchessReducer(state=[], action) {
  switch ( action.type ) {
  case 'FETCH_DUTCHESS':
    return [].concat.apply([], [...state, action.payload])
  default:
    return state;
  }
};
